export enum AppRouteEnum {
  SIGNIN = '/account/signin',
  SIGNUP = '/account/signup',
  FORGOT = '/account/forgot',
  CYCLE_HOME = '/dashboard/cycle/home',
  SECURE_ROOT = '/dashboard',
  ECOSYSTEM_HOME = '/dashboard/ecosystem',
  EMPLOYEE_SETTING_HOME = '/dashboard/employee-setting',

  //Application configuration
  APPLICATION_EMAIL = '/dashboard/config/email',

  //Planning
  ECO_SYSTEM_PLANNING_HOME = 'dashboard/ecosystem/planning/home',
  ECO_SYSTEM_PLANNING_DASHBOARD = 'dashboard/ecosystem/planning/dashboard',
  ECO_SYSTEM_PLANNING_CREATE = 'dashboard/ecosystem/planning/create',
  ECO_SYSTEM_PLANNING_UPDATE = 'dashboard/ecosystem/planning/update',
  ECO_SYSTEM_PLANNING_DETAIL = 'dashboard/ecosystem/planning/detail',
  ECO_SYSTEM_PLANNING_DELETED = 'dashboard/ecosystem/planning/deleted',

  //Event
  EVENT_HOME = 'dashboard/event',
  ECO_SYSTEM_EVENT_HOME = 'dashboard/ecosystem/event/data/home',
  ECO_SYSTEM_EVENT_CREATE = 'dashboard/ecosystem/event/data/create',
  ECO_SYSTEM_EVENT_UPDATE = 'dashboard/ecosystem/event/data/update',
  ECO_SYSTEM_EVENT_DETAIL = 'dashboard/ecosystem/event/data/detail',
  ECO_SYSTEM_EVENT_DELETED = 'dashboard/ecosystem/event/data/deleted',

  //Prestation type
  PRESTATION_TYPE_HOME = 'dashboard/prestation-type',
  ECO_SYSTEM_PRESTATION_TYPE_HOME = 'dashboard/ecosystem/prestation-type/data/home',
  ECO_SYSTEM_PRESTATION_TYPE_CREATE = 'dashboard/ecosystem/prestation-type/data/create',
  ECO_SYSTEM_PRESTATION_TYPE_UPDATE = 'dashboard/ecosystem/prestation-type/data/update',
  ECO_SYSTEM_PRESTATION_TYPE_DETAIL = 'dashboard/ecosystem/prestation-type/data/detail',
  ECO_SYSTEM_PRESTATION_TYPE_DELETED = 'dashboard/ecosystem/prestation-type/data/deleted',

  // Task
  TASK_HOME = 'dashboard/task',

  //Prestation
  ECO_SYSTEM_PRESTATION_HOME = 'dashboard/ecosystem/prestation/home',
  ECO_SYSTEM_PRESTATION_CREATE = 'dashboard/ecosystem/prestation/create',
  ECO_SYSTEM_PRESTATION_UPDATE = 'dashboard/ecosystem/prestation/update',
  ECO_SYSTEM_PRESTATION_DETAIL = 'dashboard/ecosystem/prestation/detail',
  ECO_SYSTEM_PRESTATION_DELETED = 'dashboard/ecosystem/prestation/deleted',

  // Exchange requests

  EXCHANGE_REQUEST_HOME = '/dashboard/exchange-request',

  //Generator template
  GENERATOR_TEMPLATE_HOME = 'dashboard/template',
  ECO_SYSTEM_GENERATOR_TEMPLATE_HOME = 'dashboard/ecosystem/template/home',
  ECO_SYSTEM_GENERATOR_TEMPLATE_CREATE = 'dashboard/ecosystem/template/create',
  ECO_SYSTEM_GENERATOR_TEMPLATE_UPDATE = 'dashboard/ecosystem/template/update',
  ECO_SYSTEM_GENERATOR_TEMPLATE_DETAIL = 'dashboard/ecosystem/template/detail',
  ECO_SYSTEM_GENERATOR_TEMPLATE_DELETED = 'dashboard/ecosystem/template/deleted',

  //Employee
  EMPLOYEE_HOME = 'dashboard/employee',
  ECO_SYSTEM_EMPLOYEE_HOME = 'dashboard/ecosystem/employee/data/home',
  ECO_SYSTEM_EMPLOYEE_CREATE = 'dashboard/ecosystem/employee/data/create',
  ECO_SYSTEM_EMPLOYEE_UPDATE = 'dashboard/ecosystem/employee/data/update',
  ECO_SYSTEM_EMPLOYEE_DETAIL = 'dashboard/ecosystem/employee/data/detail',
  ECO_SYSTEM_EMPLOYEE_DELETED = 'dashboard/ecosystem/employee/data/deleted',

  //Team
  TEAM_HOME = 'dashboard/team',
  SECTION_HOME = 'dashboard/team/section',
  ECO_SYSTEM_TEAM_HOME = 'dashboard/ecosystem/team/data/home',
  ECO_SYSTEM_TEAM_CREATE = 'dashboard/ecosystem/team/data/create',
  ECO_SYSTEM_TEAM_UPDATE = 'dashboard/ecosystem/team/data/update',
  ECO_SYSTEM_TEAM_DETAIL = 'dashboard/ecosystem/team/data/detail',
  ECO_SYSTEM_TEAM_DELETED = 'dashboard/ecosystem/team/data/deleted',

  //Role
  ROLE_HOME = 'dashboard/role',
  ECO_SYSTEM_ROLE_HOME = 'dashboard/ecosystem/role/data/home',
  ECO_SYSTEM_ROLE_CREATE = 'dashboard/ecosystem/role/data/create',
  ECO_SYSTEM_ROLE_UPDATE = 'dashboard/ecosystem/role/data/update',
  ECO_SYSTEM_ROLE_DETAIL = 'dashboard/ecosystem/role/data/detail',
  ECO_SYSTEM_ROLE_DELETED = 'dashboard/ecosystem/role/data/deleted',

  //Address
  ECO_SYSTEM_ADDRESS_HOME = 'dashboard/ecosystem/address/home',
  ECO_SYSTEM_ADDRESS_CREATE = 'dashboard/ecosystem/address/create',
  ECO_SYSTEM_ADDRESS_UPDATE = 'dashboard/ecosystem/address/update',
  ECO_SYSTEM_ADDRESS_DETAIL = 'dashboard/ecosystem/address/detail',
  ECO_SYSTEM_ADDRESS_DELETED= 'dashboard/ecosystem/address/deleted',

  //Remember
  REMEMBER_HOME = 'dashboard/remember',
  ECO_SYSTEM_REMEMBER_HOME = 'dashboard/ecosystem/remember/data/home',
  ECO_SYSTEM_REMEMBER_CREATE = 'dashboard/ecosystem/remember/data/create',
  ECO_SYSTEM_REMEMBER_UPDATE = 'dashboard/ecosystem/remember/data/update',
  ECO_SYSTEM_REMEMBER_DETAIL = 'dashboard/ecosystem/remember/data/detail',
  ECO_SYSTEM_REMEMBER_DELETED = 'dashboard/ecosystem/remember/data/deleted',

  //Parameter
  PARAMETER_HOME = 'dashboard/param',
  ECO_SYSTEM_PARAMETER_HOME = 'dashboard/ecosystem/param/home',
  ECO_SYSTEM_PARAMETER_CREATE = 'dashboard/ecosystem/param/create',
  ECO_SYSTEM_PARAMETER_UPDATE = 'dashboard/ecosystem/param/update',
  ECO_SYSTEM_PARAMETER_DETAIL = 'dashboard/ecosystem/param/detail',
  ECO_SYSTEM_PARAMETER_DELETED = 'dashboard/ecosystem/param/deleted',

  //Control
  CONTROL_HOME = 'dashboard/control',
  ECO_SYSTEM_CONTROL_HOME = 'dashboard/ecosystem/control/data/home',
  ECO_SYSTEM_CONTROL_CREATE = 'dashboard/ecosystem/control/data/create',
  ECO_SYSTEM_CONTROL_UPDATE = 'dashboard/ecosystem/control/data/update',
  ECO_SYSTEM_CONTROL_DETAIL = 'dashboard/ecosystem/control/data/detail',
  ECO_SYSTEM_CONTROL_DELETED = 'dashboard/ecosystem/control/data/deleted',

  // History
  ECO_SYSTEM_HISTORY_HOME = 'dashboard/ecosystem/history/home',
  ECO_SYSTEM_HISTORY_CREATE = 'dashboard/ecosystem/history/create',
  ECO_SYSTEM_HISTORY_UPDATE = 'dashboard/ecosystem/history/update',
  ECO_SYSTEM_HISTORY_DETAIL = 'dashboard/ecosystem/history/detail',
  ECO_SYSTEM_HISTORY_DELETED = 'dashboard/ecosystem/history/deleted',

  // Permission
  ECO_SYSTEM_PERMISSION_HOME = 'dashboard/ecosystem/permission/home',
  ECO_SYSTEM_PERMISSION_CREATE = 'dashboard/ecosystem/permission/create',
  ECO_SYSTEM_PERMISSION_UPDATE = 'dashboard/ecosystem/permission/update',
  ECO_SYSTEM_PERMISSION_DETAIL = 'dashboard/ecosystem/permission/detail',
  ECO_SYSTEM_PERMISSION_DELETED = 'dashboard/ecosystem/permission/deleted',

  // Permission
  ECO_SYSTEM_VISUALISATIONPRESTATIONTYPE_HOME = 'dashboard/ecosystem/visual-prestation-type/home',
  ECO_SYSTEM_VISUALISATIONPRESTATIONTYPE_CREATE = 'dashboard/ecosystem/visual-prestation-type/create',
  ECO_SYSTEM_VISUALISATIONPRESTATIONTYPE_UPDATE = 'dashboard/ecosystem/visual-prestation-type/update',
  ECO_SYSTEM_VISUALISATIONPRESTATIONTYPE_DETAIL = 'dashboard/ecosystem/visual-prestation-type/detail',
  ECO_SYSTEM_VISUALISATIONPRESTATIONTYPE_DELETED = 'dashboard/ecosystem/visual-prestation-type/deleted',

  // Leave
  LEAVE_HOME='dashboard/leave',

  // Help
  HELP_PLANNING = 'dashboard/help/planning',
  HELP_PRESTATION_TYPE = 'dashboard/help/prestationType',
  HELP_PRESTATION = 'dashboard/help/prestation',
  HELP_TEMPLATE = 'dashboard/help/template',
  HELP_EMPLOYEE = 'dashboard/help/employee',
  HELP_TEAM = 'dashboard/help/team',
  HELP_ROLE = 'dashboard/help/role',
  HELP_ADDRESS = 'dashboard/help/address',
  HELP_REMEMBER = 'dashboard/help/remember',
  HELP_PARAMETER = 'dashboard/help/parameter',
  HELP_CONTROL = 'dashboard/help/control',
  HELP_HISTORY = 'dashboard/help/history',
  HELP_PERMISSION = 'dashboard/help/permission',
  HELP_VISUALISATIONPRESTATIONTYPE = 'dashboard/help/visual-prestation-type',

  // Planning restriction
  PLANNING_RESTRICTION = 'dashboard/planning-restrictions',

  // Rank
  RANK = 'dashboard/rank',

  // Absences
  ABSENCE = 'dashboard/absence',

  // Absences types
  ABSENCE_TYPE = 'dashboard/absence-type',

  // Quotas 
  QUOTAS_HOME = 'dashboard/quotas',
}

